/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import omit from "lodash/fp/omit";

import ApiCaller from "~/api/ApiCaller";
import {
  PostForcedPasswordResetRequestBody,
  PostForcedPasswordResetResponse,
  PostForgotPasswordRequestBody,
  PostForgotPasswordResponse,
  PostResetPasswordRequestBody,
  PostResetPasswordResponse,
} from "~/features/forgotPassword/types";

const ForgotPasswordApi = {
  postForgotPassword: (data: PostForgotPasswordRequestBody) => {
    const url = "/v1/password/forgotpassword";

    return ApiCaller.post<PostForgotPasswordResponse>(url, omit("recaptchaToken", data), {
      headers: { ["x-recaptcha-token"]: data.recaptchaToken },
    });
  },
  postResetPassword: (data: PostResetPasswordRequestBody) => {
    const url = "/v1/password/resetpassword";

    return ApiCaller.post<PostResetPasswordResponse>(url, data);
  },
  postForcedPasswordReset: (data: PostForcedPasswordResetRequestBody) => {
    const url = "v1/password/forcedpasswordreset";

    return ApiCaller.post<PostForcedPasswordResetResponse>(url, data);
  },
};

export default ForgotPasswordApi;
